// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_33974c2b58--checkbox--oMeNF","box":"_33974c2b58--box--aD_nX","label":"_33974c2b58--label--iT_qr"};